import { StrictMode } from 'react';
import { render } from 'react-dom';
import { MemoryRouter as Router } from 'react-router-dom';
import 'scss/index.scss';
import App from './app';

render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
  document.getElementById('root')
);